export const environment = {
  production: false,
  BASE_API_URL : 'https://devapis.govtow.com/OnlineAuction/',
  WebUrl : 'https://dev.govtow.com/GovtowAuction/',
  VehicleTemplateUrl : 'https://devapis.govtow.com/OnlineAuction/Templates/Product_Template.xlsx',
  GoogleMapAPIKey : 'AIzaSyCeuLWeImbjN_kHGw_E-8U1_aF0g3YwAxE',
  GoogleCaptchav2Key: '6LeZh7MZAAAAAGzyw9vu8QUlqe0nLgndUyoE1ynG'
};

